(function () {
    function initMainCollection(sectionElement) {
        if (!sectionElement || sectionElement.dataset.initialized === 'true') {
            return;
        }

        sectionElement.dataset.initialized = 'true';

        var drawer = sectionElement.querySelector('[data-filter-drawer]');
        var overlay = sectionElement.querySelector('[data-filter-overlay]');
        var openButton = sectionElement.querySelector('[data-filter-open]');
        var closeButton = sectionElement.querySelector('[data-filter-close]');
        var form = sectionElement.querySelector('[data-collection-filters-form]');

        function openDrawer() {
            if (!drawer) {
                return;
            }

            drawer.classList.add('is-open');
            drawer.setAttribute('aria-hidden', 'false');

            if (overlay) {
                overlay.hidden = false;
            }

            if (openButton) {
                openButton.setAttribute('aria-expanded', 'true');
            }
        }

        function closeDrawer() {
            if (!drawer) {
                return;
            }

            drawer.classList.remove('is-open');
            drawer.setAttribute('aria-hidden', 'true');

            if (overlay) {
                overlay.hidden = true;
            }

            if (openButton) {
                openButton.setAttribute('aria-expanded', 'false');
            }
        }

        if (openButton) {
            openButton.addEventListener('click', openDrawer);
        }

        if (closeButton) {
            closeButton.addEventListener('click', closeDrawer);
        }

        if (overlay) {
            overlay.addEventListener('click', closeDrawer);
        }

        if (form) {
            form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
                input.addEventListener('change', function () {
                    form.requestSubmit();
                });
            });
        }

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                closeDrawer();
            }
        });
    }

    window.VitalifyMainCollection = {
        init: initMainCollection
    };
})();
